<template>
  <!--
    Komponent wyświetlający aktywne numery pasów jako filtry.
    Pokazuje listę wybranych pasów z możliwością usunięcia filtrów.
  -->
  <div v-if="store.filters.laneNumbers && store.filters.laneNumbers.length > 0" class="filter d-flex flex-column">
    <h5 class="margin-0">
      {{ t('lanes') }}  <!-- Tytuł sekcji: "Pasy" (przetłumaczone) -->
      <!-- Przycisk usuwania wszystkich filtrów pasów -->
      <span class="icon-trash" @click="removeFilter()" role="button"></span>
    </h5>

    <!-- Lista zaznaczonych numerów pasów -->
    <div
      v-for="(lane, key) in store.filters.laneNumbers"
      :key="key"
      class="collapse show"
      id="laneNumbers"
    >
      <div class="info d-flex">
        <!-- Checkbox dla każdego pasa (zawsze zaznaczony w widoku) -->
        <input-checkbox
          :field-name="key"
          field-value=""
          :checkedCondition="true"
          @clicked="setFilter(lane)"
        />
        <!-- Wyświetlenie numeru pasa -->
        <p class="margin-0">{{ lane }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import InputCheckbox from "../InputCheckbox.vue";  // Komponent checkbox

export default {
  name: "LaneNumbersFilterView",  // Nazwa komponentu
  props: {
    store: { required: true },  // Przekazany store z filtrami
  },
  components: { InputCheckbox },
  methods: {
    /**
     * Przełącza zaznaczenie danego pasa
     * @param {number|string} lane - numer pasa
     */
    setFilter(lane) {
      // Dodaje lub usuwa filtr dla konkretnego pasa
      this.store.addItem(
        "LaneNumbers",
        this.store.laneNumbers.indexOf(lane)
      );
    },
    /**
     * Usuwa wszystkie filtry pasów (resetuje listę)
     */
    removeFilter() {
      this.store.removeItem("laneNumbers");
    },
  },
};
</script>

<style scoped>
/* Kontener filtra */
.filter {
  width: 100%;
}

/* Styl nagłówka sekcji */
.filter h5 {
  margin: 0;
  padding: var(--spacing-md) var(--spacing-lg);
  position: relative;
  background: var(--surface-secondary);
  border-bottom: 1px solid var(--border-default);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-bold);
  letter-spacing: var(--letter-spacing-caps);
  text-transform: uppercase;
  color: var(--text-primary);
}

/* Marginesy między pozycjami */
.filter .collapse {
  margin: 3px 0;
}
.filter .collapse:nth-of-type(1) {
  margin-top: 10px;
}
.filter .collapse:last-child {
  margin-bottom: 10px;
}

/* Kontener informacji w wierszu */
.info {
  font-size: var(--font-size-sm);
  padding: var(--spacing-sm) var(--spacing-lg);
  display: flex;
  align-items: center;
}
.info p {
  font-size: var(--font-size-sm);
  margin: 0;
  margin-left: 5px;
}

/* Ikona kosza do usuwania filtrów */
.icon-trash {
  background: url("../../assets/icons/trash.svg") no-repeat left top;
  width: 15px;
  height: 17px;
  position: absolute;
  cursor: pointer;
  top: 8px;
  right: 10px;
}
</style>
